document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('product-grid');
  if (!grid) return;

  let currentPage = parseInt(grid.dataset.currentPage, 10) || 1;
  const totalPages = parseInt(grid.dataset.totalPages, 10) || 1;
  const loader = document.getElementById('infinite-scroll-loader');
  let isLoading = false;

  window.addEventListener('scroll', function () {
    if (isLoading || currentPage >= totalPages) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.body.offsetHeight;

    // Jab user page ke bottom se 600px door ho, load karo
    if (scrollPosition >= pageHeight - 600) {
      loadNextPage();
    }
  });

  function loadNextPage() {
    isLoading = true;
    currentPage++;
    if (loader) loader.style.display = 'block';

    const url = `${window.location.pathname}?page=${currentPage}&section_id=main-collection-product-grid`;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('#product-grid');

        if (newGrid) {
          Array.from(newGrid.children).forEach(child => {
            child.classList.add('infinite-scroll-item');
            grid.appendChild(child);
            // Thoda delay dene se browser ko transition apply karne ka time milta hai
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                child.classList.add('infinite-scroll-item--visible');
              });
            });
          });
        }

        if (loader) loader.style.display = 'none';
        isLoading = false;
      })
      .catch(err => {
        console.error('Infinite scroll error:', err);
        isLoading = false;
        if (loader) loader.style.display = 'none';
      });
  }
});